import { Tabs } from 'antd';
import { useEffect, useState } from 'react';
import DensityHeatmap from '../Charts/DensityHeatmap';
import LinePlot from '../Charts/LinePlot';
import { GlobalOutlined, LineChartOutlined, PushpinOutlined } from '@ant-design/icons';
import NutrientCountries from './NutrientCountries';

const NutrientDistricts = (props) => {
  const [anyPlotData, setAnyPlotData] = useState([]);
  const [deficiencyPlotData, setDeficiencyPlotData] = useState([]);
  const [excessPlotData, setExcessPlotData] = useState([]);
  const [countriesPlotData, setCountriesPlotData] = useState([]);

  useEffect(() => {
    asyncFetchAnyData('data/correlation/any_correlation_relative_values.json', setAnyPlotData);
    asyncFetchAnyData('data/correlation/deficiency_correlation_relative_values.json', setDeficiencyPlotData);
    asyncFetchAnyData('data/correlation/excess_correlation_relative_values.json', setExcessPlotData);
    asyncFetchAnyData('data/nutrients/nutrient_countries.json', setCountriesPlotData);
  }, []);

  const asyncFetchAnyData = (url, setData) => {
    fetch(url)
      .then((response) => response.json())
      .then((json) => {
        setData(json[props.label.toLowerCase()]);
      })
      .catch((error) => {
        console.log('fetch data failed', error);
      });
  };

  const tabItems = [
    {
      key: '1',
      label: (
        <span>
          Portugal <PushpinOutlined />
        </span>
      ),
      children: (
        <DensityHeatmap
          label={props.label}
          className="bg-alt-2"></DensityHeatmap>
      ),
    },
    {
      key: '2',
      label: (
        <span>
          Cronologia <LineChartOutlined />
        </span>
      ),
      children: (
        <LinePlot
          data={anyPlotData}
          hasSeries={true}></LinePlot>
      ),
    },
    {
      key: '3',
      label: (
        <span>
          Deficiência Nutricional <LineChartOutlined />
        </span>
      ),
      children: (
        <LinePlot
          data={deficiencyPlotData}
          hasSeries={true}></LinePlot>
      ),
    },
    {
      key: '4',
      label: (
        <span>
          Excesso Nutricional <LineChartOutlined />
        </span>
      ),
      children: (
        <LinePlot
          data={excessPlotData}
          hasSeries={true}></LinePlot>
      ),
    },
    {
      key: '5',
      label: (
        <span>
          Menção de Países <GlobalOutlined />
        </span>
      ),
      children: <NutrientCountries data={countriesPlotData}></NutrientCountries>,
    },
  ];

  return (
    <Tabs
      defaultActiveKey="1"
      items={tabItems}></Tabs>
  );
};

export default NutrientDistricts;
